export default {
  title: 'إعادة شحن',
  price: 'السعر {{price}}',
  limit: 'عرض محدود <span>{{time}}</span> لـ {{doniaNo}} يرجى الدفع في أقرب وقت ممكن',
  rate: '$1 = <span>{{coins}}عملات ذهبية</span>',
  totalCoins: 'إجمالي العملات: <span>{{coins}}</span>',
  bonus: 'مكافأة',
  discountOff: '{{percent}}% خصم',
  invalidLink: 'رابط إعادة الشحن غير صالح',
  loadFailed: 'فشل تحميل معلومات إعادة الشحن',
};
